import { render } from "./StockDeliveryNotesTable.vue?vue&type=template&id=b334b172&scoped=true"
import script from "./StockDeliveryNotesTable.vue?vue&type=script&lang=js"
export * from "./StockDeliveryNotesTable.vue?vue&type=script&lang=js"

import "./StockDeliveryNotesTable.vue?vue&type=style&index=0&id=b334b172&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b334b172"]])

export default __exports__